import { Injectable } from '@angular/core';
import {
  NbAuthJWTToken,
  NbAuthResult,
  NbAuthStrategy,
  NbAuthStrategyClass,
  NbAuthStrategyOptions,
} from '@nebular/auth';
import { Observable, of } from 'rxjs';

/**
 * This class was implemented to manage jwt that can be passed by query params
 * It's useful notably to open a page coming from insigth without asking the user to re-authenticate
 */
@Injectable()
export class JWTStrategy extends NbAuthStrategy {

  protected defaultOptions: NbAuthStrategyOptions = {
    name: 'jwt',
    token: {
      name: 'jwt',
      class: NbAuthJWTToken,
    },
  };

  static setup(options: NbAuthStrategyOptions): [NbAuthStrategyClass, NbAuthStrategyOptions] {
    return [JWTStrategy, options];
  }

  authenticate(jwt: string): Observable<NbAuthResult> {
    const authResult = new NbAuthResult(
      true,
      {},
      null,
      null,
      null,
      this.createToken<NbAuthJWTToken>(jwt),
    );

    return of(authResult);
  }

  register(_data?: any): Observable<NbAuthResult> {
    throw new Error('`register` is not supported by `JWTStrategy`.');
  }

  requestPassword(_data?: any): Observable<NbAuthResult> {
    throw new Error('`requestPassword` is not supported by `JWTStrategy`.');
  }

  resetPassword(_data?: any): Observable<NbAuthResult> {
    throw new Error('`resetPassword` is not supported by `JWTStrategy`.');
  }

  logout(): Observable<NbAuthResult> {
    return of(new NbAuthResult(true));
  }

  refreshToken(_data?: any): Observable<NbAuthResult> {
    throw new Error('`refreshToken` is not supported by `JWTStrategy`.');
  }

}
